import theme from "../../../../js/shared/new-theme";

import {
	fontSize16,
	gridGutter1q3
} from "@maxmilhas/hangar-components-atomic/public/styles/components/quarks/layout";

export const boxOfferRegisteredStyle = `
  display: flex;
  align-items: center;
  flex-direction: column;

  i {
    color: ${theme.palette.common.white}
  }

  .area-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 35px;
    width: 35px;
    background-color: ${theme.palette.green[500].value};
    color: ${theme.palette.common.white};
    border-radius: 28px;
    font-size: ${fontSize16};
    margin: 0 ${gridGutter1q3 * 2}px ${gridGutter1q3 * 2}px;
  }

  .wrong-phone-area-icon {
    background-color: ${theme.palette.red[500].value};
  }

  .area-text {
    width: 45%;
    text-align: center;
    p {
      margin: 0;
    }
    span {
      font-weight: bold;
    }
    &--title {
      color: ${theme.palette.gray[800].value};
      font-size: ${fontSize16};
      font-weight: bold;
      margin-bottom: 4px !important;
    }

    &--link {
      font-size: ${fontSize16};
      color: ${theme.palette.gray[800].value};
      min-width: 90px;
      border: none;
      padding: 0px 10px;
      height: auto;
      font-size: 14px;
      min-width: 100px;
      padding-left: 4px
    }
  }

  .mt-16 {
    margin-top: 16px
  }
`;
